<template>
  <div class="countdown flex items-center">
    <img class="img" src="@/render/assets/images/clock.png" />
    <span class="name">{{ time }}</span>
  </div>
</template>

<script>
import store from 'store'
import { WS_GAME_CONFIGS } from '@/config/const'
const timerArray = []
export default {
  name: 'Countdown',
  props: {},
  data() {
    return {
      timeStart: false, // 是否继续倒数
      minutes: '', // 分钟存储
      seconds: '00', // 秒数存储
      time: '', // 显示分秒
      addSeconds: 0, // 加秒额度
      coefficient: 0, // 系数
      isAddSecond: false, // 是否可以加时间
    }
  },
  components: {},
  computed: {},
  mounted() {
    const configs = store.get(WS_GAME_CONFIGS).mode.split(',')
    let t = configs[0] || 0
    this.addSeconds = configs[1] || 0
    this.coefficient = Math.floor(this.addSeconds / 60) + 1
    this.seconds = t % 60 > 9 ? `${t % 60}` : `0${t % 60}`
    this.minutes = parseInt(t / 60) > 9 ? `${parseInt(t / 60)}` : `0${parseInt(t / 60)}`
    this.time = `${this.minutes}: ${this.seconds}`
  },
  beforeDestroy() {
    this.stop()
  },
  methods: {
    start() {
      this.timeStart = true
      this.reciprocal()
    },
    stop() {
      this.timeStart = false
      this.clearTimer()
    },
    clearTimer() {
      for (let i = 0; i < timerArray.length; i++) {
        clearTimeout(timerArray[i])
      }
    },
    end() {
      this.$emit('timeOver', true)
    },
    reciprocal() {
      this.isAddSecond = true
      let m = parseInt(this.minutes)
      let s = parseInt(this.seconds)
      // 判断是否结束
      if (m <= 0 && s === 0) {
        this.end()
        this.isAddSecond = false
        this.stop()
        return false
      }
      // 未结束判断是否继续归减秒
      if (this.timeStart) {
        const timer = setTimeout(() => {
          this.subtract(m, s)
          this.reciprocal()
        }, 1000)
        timerArray.push(timer)
      }
    },
    // 减秒操作
    subtract(m, s) {
      if (s === 0) {
        s = '59'
        m--
      } else {
        s--
      }
      this.$store.commit('grading/setEachTime', m * 60 + s)
      this.assignment(m, s)
    },
    // 加秒操作
    add() {
      let m = parseInt(this.minutes)
      let s = parseInt(this.seconds)
      s += parseInt(this.addSeconds)
      if (s >= (60 * this.coefficient)) {
        m += this.coefficient
        s -= (60 * this.coefficient)
      }
      this.assignment(m, s)
    },
    // 分钟
    assignment(m, s) {
      this.minutes = m > 9 ? `${m}` : `0${m}`
      this.seconds = s > 9 ? `${s}` : `0${s}`
      this.time = `${this.minutes}: ${this.seconds}`
    }
  },
}
</script>

<style lang="scss" scoped>
.countdown {
  color: #3E2C00;
  font-size: val(20);
  font-weight: 500;
  .img {
    width: val(27);
    height: val(24);
    margin-right: val(15);
  }
}
</style>
